// The admin dashboard's holiday date arithmetic (backfill PR 32): the three dates the holiday
// modal shows beside the chosen period, a mirror of the backend's getHolidayDates in
// backend/utils/holidayUtils.js, whose answer the banner and the checkout read; the test runs
// both over the same periods.
export const addDaysToDateOnly = (dateString, days) => {
  if (!dateString) {
    return ''; // return an empty value if no date was provided
  }

  const [year, month, day] = dateString.split('-').map(Number); // split the YYYY-MM-DD string into numeric year, month and day values
  const timestamp = Date.UTC(year, month - 1, day); // convert the calendar date into a UTC timestamp so timezone differences do not change the date

  return new Date(timestamp + days * 24 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, 10); // add or subtract the requested days and convert the result back to YYYY-MM-DD
}; // adds or subtracts days from a date-only value without letting timezones shift the calendar date
